export default __webpack_public_path__ + "media/welli-insight-glp1-companion.27912d0050894ce30d09f8955b52c169.webp";